var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-pin-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7868 10.416C12.1675 10.416 13.2868 9.29673 13.2868 7.91602C13.2868 6.5353 12.1675 5.41602 10.7868 5.41602C9.40607 5.41602 8.28678 6.5353 8.28678 7.91602C8.28678 9.29673 9.40607 10.416 10.7868 10.416Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7868 18.3327C12.4535 14.9993 17.4535 12.8479 17.4535 8.33268C17.4535 4.65078 14.4687 1.66602 10.7868 1.66602C7.10489 1.66602 4.12012 4.65078 4.12012 8.33268C4.12012 12.8479 9.12012 14.9993 10.7868 18.3327Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.76a64ee3c3b90836a18f6a5e4c0bcd5c.svg";
export { ForwardRef as ReactComponent };